// removed by extract-text-webpack-plugin
module.exports = {"root":"rootWrapper__root--3A3K1","wrapper":"rootWrapper__wrapper--USz3F","wrapperReady":"rootWrapper__wrapperReady--eU9Zk rootWrapper__wrapper--USz3F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/RootWrapper/rootWrapper.css
// module id = TqjJ
// module chunks = 0